enum ItemStates {
  PENDING = "pending",
  STARTED = "started",
  FAILED = "failed",
  SUCCESSFUL = "successful",
}

export default ItemStates
